import { useEffect } from 'react';

import { LoginCallback } from '@okta/okta-react';
import { useTranslation } from 'react-i18next';

import { AmplitudeProductEvent } from '@cfa/pathway-fe-shared';

import Constants from '@/constants';

import ConfirmationModal from 'components/popups/ConfirmationModal';
import { isAccessDeniedError } from 'utils/error';

import GenericError from '../components/Error/GenericError';

import { useAmplitudeTrack } from '@/amplitude/useAmplitude';

const CustomLoginCallback: React.FC = () => {
  const track = useAmplitudeTrack();

  useEffect(() => {
    track(AmplitudeProductEvent.LOGIN_SUCCESS, {});
  }, [track]);

  return <LoginCallback errorComponent={RenderError} />;
};

const RenderError: React.FC<{ error: Error }> = ({ error }) => {
  const { t } = useTranslation();
  const homeUrl = Constants.CFA_HOME_URL ?? '/';

  const redirectToHome = () => {
    window.location.href = homeUrl;
  };

  return isAccessDeniedError(error) ? (
    <ConfirmationModal
      bodyText={t('UserNotAssignedToAppError.errorParagraph')}
      headerText={t('GenericError.unauthorized')}
      isError={true}
      isOpen={true}
      onClose={redirectToHome}
      primaryButtonHandler={redirectToHome}
      primaryButtonText={t('Button.returnToCfa')}
    />
  ) : (
    <GenericError />
  );
};

export default CustomLoginCallback;
